import React from 'react';

const Connecticut = () => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.85791 5.0049C7.48974 3.6108 13.8892 1.99139 20.3099 0.400146C21.1758 3.96988 22.6754 6.90593 22.8725 11.1516C19.7537 10.7221 18.5146 14.834 16.2195 12.1725C16.1773 13.5666 17.0714 13.2005 16.2195 14.2214C13.671 14.7495 11.4604 14.9326 9.56658 16.2703C9.03857 16.6435 9.01044 17.4109 8.54579 17.8052C8.24307 18.0587 7.32781 17.5658 7.011 17.8052C6.56747 18.1432 6.87725 18.9599 6.49708 19.3402C6.15916 19.6781 5.3073 19.5232 4.96233 19.8541C4.3076 20.4808 3.93449 21.6777 2.91367 21.903C2.32229 21.9875 2.00548 21.7904 1.89284 21.3891C1.44227 19.7415 3.58247 20.685 3.42758 19.3402C2.54757 14.5805 1.09024 10.4053 0.85791 5.0049Z"
      fill="#FC374D"
    />
  </svg>
);
export default Connecticut;
